/**
 * @generated SignedSource<<9573640caef5a9f0bbbfd27b166274d8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Recipients_address$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useSplit_address">;
  readonly " $fragmentType": "Recipients_address";
};
export type Recipients_address$key = {
  readonly " $data"?: Recipients_address$data;
  readonly " $fragmentSpreads": FragmentRefs<"Recipients_address">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Recipients_address",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSplit_address"
    }
  ],
  "type": "EthereumAddressType",
  "abstractKey": null
};

(node as any).hash = "600305eb3bb1721113061e37788b7752";

export default node;
